<template>
    <div class='branchChildPage3'>
        <div class='tabbox'>
            <div v-for="(item,index) in tablist" :key='index' :class="activename==item.name?'activeitemName':'itemName'" @click="checkTab(item)">
                {{item.name}}
            </div>
        </div>
        <div class="pagebox">
            <div v-if="activename=='分会介绍'"><RecommendPage/></div>
            <div v-if="activename=='主要负责人'"><PrincipalPage/></div>
            <div v-if="activename=='业务活动介绍'"><ActivityPage/></div>

        </div>
    </div>
</template>

<script >
import RecommendPage from './components/recommendPage.vue'
import PrincipalPage from './components/principalPage.vue'
import ActivityPage from './components/activityPage.vue'
export default {
    components:{
        RecommendPage,
        PrincipalPage,
        ActivityPage
    },
    data() {
        return {
            tablist: [
                { name: '分会介绍' },
                { name: '主要负责人' },
                { name: '业务活动介绍' },
            ],
            activename:'分会介绍'
        }
    },
    methods:{
        checkTab(item){
            this.activename=item.name
        }
    }

}
</script>

<style lang="less" scoped>
.branchChildPage3 {
	width: 100%;
	.tabbox {
		display: flex;
		flex-direction: row;
		justify-content: center;
		font-size: 20px;
		line-height: 35px;
		border-bottom: 1px solid #448df7;
		// padding-bottom: 2px;
		.itemName {
			padding: 0 20px;
			color: #333333;
			cursor: pointer;
			&:nth-child(2) {
				margin: 0 60px;
			}
		}
		.activeitemName {
			background: #448df7;
			padding: 0 20px;
			color: #fff;
			position: relative;
			&:nth-child(2) {
				margin: 0 60px;
			}
		}
		.activeitemName::before {
			content: '';
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			top: 36px;
			width: 0;
			height: 0;
			border: 5px solid transparent;
			border-top-color: #448df7;
		}
	}
    .pagebox{
        margin-top: 30px;
    }
}
</style>
